<script setup lang="ts">
import TicketCreatePage from '@/components/TicketComponents/TicketCreatePage.vue'
import { TICKETS_ROUTES } from '@/router/routes'
</script>

<template>
    <TicketCreatePage
        :editButtonHref="TICKETS_ROUTES.baseUrl"
        :createButtonHref="TICKETS_ROUTES.createUrl" />
</template>
